import { render } from "./TiesList.vue?vue&type=template&id=34b41c2e&scoped=true"
import script from "./TiesList.vue?vue&type=script&lang=js"
export * from "./TiesList.vue?vue&type=script&lang=js"

import "./TiesList.vue?vue&type=style&index=0&id=34b41c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b41c2e"]])

export default __exports__